import React from 'react'

function Selector({ handleOnChange, selectedOption, options }) {
  return options?.length === 0 ? null : (
    <div className='selectorContainer'>
      <label htmlFor="sorting-select">Sortuj:</label>

      <select value={selectedOption} name="sorting-filters" id="sorting-select" onChange={handleOnChange}>
        {options.map(([key, value], index) =>
          <option key={key} value={value}>{key}</option>
        )}
      </select>
    </div >
  )
}

export default Selector